import { render, staticRenderFns } from "./FormAlignmentMGHRWC.vue?vue&type=template&id=c1e0fe7a&scoped=true&"
import script from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
export * from "./FormAlignmentMGHRWC.vue?vue&type=script&lang=ts&"
import style0 from "./FormAlignmentMGHRWC.vue?vue&type=style&index=0&id=c1e0fe7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e0fe7a",
  null
  
)

export default component.exports